import React, { useMemo } from "react";
import "../css/WalkingServiceCard.css";

const WalkingServiceCard = ({ data = [] }) => {
  // 🔍 Find the "Walking" service object from the parent data
  const walkingData = useMemo(
    () => data.find((item) => item.service === "Walking"),
    [data]
  );

  // 🧮 Extract values safely with fallbacks
  const totalServices = walkingData?.overall_walking_services || 0;
  const totalRevenue = walkingData?.overall_walking_service_revenue || 0;
  const ongoingCount = walkingData?.ongoing_service || 0;
  const pendingCount = walkingData?.pending_service || 0;
  const completedCount = walkingData?.completed_services || 0;
  const bestPartner = walkingData?.best_walking_partner || "—";

  return (
    <div className="walking-service-card">
      <div className="walking-service-title">Walking</div>
      <div className="walking-service-content">
        <div className="walking-service-row">
          <span className="walking-service-label">Overall Walking Services</span>
          <span className="walking-service-colon">:</span>
          <span className="walking-service-value">{totalServices}</span>
        </div>

        <div className="walking-service-row">
          <span className="walking-service-label">
            Overall Walking Service Revenue
          </span>
          <span className="walking-service-colon">:</span>
          <span className="walking-service-value">
            ₹{totalRevenue.toLocaleString()}
          </span>
        </div>

        <div className="walking-service-row">
          <span className="walking-service-label">Ongoing Service</span>
          <span className="walking-service-colon">:</span>
          <span className="walking-service-value">{ongoingCount}</span>
        </div>

        <div className="walking-service-row">
          <span className="walking-service-label">Pending Service</span>
          <span className="walking-service-colon">:</span>
          <span className="walking-service-value">{pendingCount}</span>
        </div>

        <div className="walking-service-row">
          <span className="walking-service-label">Completed Service</span>
          <span className="walking-service-colon">:</span>
          <span className="walking-service-value">{completedCount}</span>
        </div>

        <div className="walking-service-row">
          <span className="walking-service-label">Best Walking Partner</span>
          <span className="walking-service-colon">:</span>
          <span className="walking-service-value">{bestPartner}</span>
        </div>
      </div>
    </div>
  );
};

export default WalkingServiceCard;
